import { Target, Settings, Zap, TrendingUp } from "lucide-react";

const Journey = () => {
  const steps = [
    {
      step: "PASSO 1",
      title: "Onboarding e alinhamento estratégico",
      description: "Nosso time de especialistas inicia entendendo seus objetivos de vendas, apresentando a visão geral da solução e alinhando critérios de qualificação e o tom de comunicação da sua marca.",
      icon: Target,
      bgColor: "bg-blue-50",
      iconColor: "text-blue-600"
    },
    {
      step: "PASSO 2", 
      title: "Mapeamento e integração",
      description: "Realizamos reuniões rápidas para conhecer seu público, funil de vendas e processos internos. Conectamos o Agente de SDR ao seu CRM e canais de atendimento, configurando as automações iniciais.",
      icon: Settings,
      bgColor: "bg-purple-50",
      iconColor: "text-purple-600"
    },
    {
      step: "PASSO 3",
      title: "Ativação e demonstração ao vivo",
      description: "O Agente de SDR entra em operação, respondendo, qualificando e registrando leads em tempo real. Você acompanha como ele personaliza cada abordagem e agenda reuniões automaticamente.",
      icon: Zap,
      bgColor: "bg-green-50", 
      iconColor: "text-green-600"
    },
    {
      step: "PASSO 4",
      title: "Ajustes e otimizações",
      description: "Monitoramos os primeiros resultados e aplicamos melhorias com base em dados reais, ajustando cadências, mensagens e filtros de qualificação para garantir máxima conversão e eficiência.",
      icon: TrendingUp,
      bgColor: "bg-orange-50",
      iconColor: "text-orange-600"
    }
  ];

  return (
    <section id="demonstracao" className="py-16 px-4 sm:px-6 lg:px-8 bg-gradient-subtle">
      <div className="mx-auto max-w-6xl">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="text-heading text-foreground mb-6">
            Como será a sua{" "}
            <span className="bg-gradient-hero bg-clip-text text-transparent">
              jornada
            </span>{" "}
            com o Agente de SDR com IA
          </h2>
          <p className="text-body-large text-muted-foreground max-w-3xl mx-auto">
            Do primeiro contato até a otimização contínua: um processo estruturado para maximizar seus resultados.
          </p>
        </div>

        {/* Steps Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {steps.map((step, index) => {
            const Icon = step.icon;
            
            return (
              <div key={index} className="group">
                <div className="bg-card rounded-3xl p-6 border border-border/50 shadow-soft hover:shadow-hover transition-all duration-300 h-full">
                  {/* Step Badge */}
                  <div className="badge-accessible mb-4">
                    {step.step}
                  </div>
                  
                  {/* Icon */}
                  <div className="mb-4">
                    <div className={`inline-flex items-center justify-center w-16 h-16 ${step.bgColor} rounded-2xl group-hover:scale-110 transition-transform duration-300`}>
                      <Icon size={32} className={step.iconColor} />
                    </div>
                  </div>
                  
                  {/* Content */}
                  <h3 className="text-xl font-semibold text-foreground mb-3">
                    {step.title}
                  </h3>
                  
                  <p className="text-muted-foreground leading-relaxed">
                    {step.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>

      </div>
    </section>
  );
};

export default Journey;